import { render, staticRenderFns } from "./PrizeData.vue?vue&type=template&id=1ad39b40&scoped=true&"
import script from "./PrizeData.vue?vue&type=script&lang=js&"
export * from "./PrizeData.vue?vue&type=script&lang=js&"
import style0 from "./PrizeData.vue?vue&type=style&index=0&id=1ad39b40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad39b40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ad39b40')) {
      api.createRecord('1ad39b40', component.options)
    } else {
      api.reload('1ad39b40', component.options)
    }
    module.hot.accept("./PrizeData.vue?vue&type=template&id=1ad39b40&scoped=true&", function () {
      api.rerender('1ad39b40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ActivityData/PrizeData.vue"
export default component.exports